import { Component, OnInit } from '@angular/core'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { CronOptions } from '../../models/cron-options'

@Component({
  selector: 'jml-lib-cron-editor-dialog',
  templateUrl: './cron-editor-dialog.component.html',
  styleUrls: ['./cron-editor-dialog.component.scss']
})
export class CronEditorDialogComponent implements OnInit {
  //cronExpression = '0 0 1/1 * *';
  cronExpression = '0 0 0/1 * * ?'
  saveButtonLabel: string = 'Übernehmen;'

  cronOptions: CronOptions = {
    defaultTime: '10:00:00',
    use24HourTime: true,

    hideMinutesTab: false,
    hideHourlyTab: false,
    hideDailyTab: false,
    hideWeeklyTab: false,
    hideMonthlyTab: false,
    hideYearlyTab: false,
    hideAdvancedTab: false,

    hideSeconds: false
  }

  constructor(
    public ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    if (this.config.data?.cronExpression) {
      this.cronExpression = this.config.data?.cronExpression
    }

    if (this.config.data?.saveButtonLabel) {
      this.saveButtonLabel = this.config.data?.saveButtonLabel
    }
  }
}
